export default "__VITE_ASSET__DV9WL4Yb__"